function handleSelectChange() {
    var oldVariant = document.querySelector(".price.axt-cp-custom").getAttribute("axt-cp-variant-id");
    var variantId = document.querySelector('[name="id"]').value;
    var productId = document.querySelector('[name="product-id"]').value;

    var priceElement = document.querySelector(".price.axt-cp-custom");
    priceElement.classList.add(variantId, productId);
    priceElement.id = variantId;
    priceElement.setAttribute("axt-cp-variant-id", productId);
}

// Add event listeners to both select elements
const selectElements = [document.getElementById("data-variant-option-0"), document.getElementById("data-variant-option-1")];
if(selectElements[0] !=null ||  selectElements[1] !=null){
  selectElements.forEach(selectElement => {
    selectElement.addEventListener("change", handleSelectChange);
});
}
